// extracted by mini-css-extract-plugin
export default {"picture":"picture-vtev","item":"item-CU6d","items":"items-Je_k"};